import { combineReducers } from "redux";
import { httpRequestsOnLoadReducer } from "../http_requests_on_load";
import { httpRequestsOnSuccessReducer } from "../http_requests_on_success";
import { httpRequestsOnErrorsReducer } from "../http_requests_on_errors";
import { authReducer } from "../auth";
import { payerReducer } from "../payer";
import { avatarReducer } from "../avatar";
import { noteReducer } from "../notes";
import { facilitiesReducer } from "../facilities";
import { usersReducer } from "../users";
import { employeesReducer } from "../employees";
import { patientsReducer } from "../patients";
import { vehiclesReducer } from "../vehicles";
import { legsReducer } from "../legs";
import { historyReducer } from "../history";

export const appReducer = combineReducers({
  auth: authReducer,
  users: usersReducer,
  payers: payerReducer,
  avatar: avatarReducer,
  notes: noteReducer,
  facilities: facilitiesReducer,
  employees: employeesReducer,
  patients: patientsReducer,
  vehicles: vehiclesReducer,
  legs: legsReducer,
  history: historyReducer,

  httpOnLoad: httpRequestsOnLoadReducer,
  httpOnSuccess: httpRequestsOnSuccessReducer,
  httpOnError: httpRequestsOnErrorsReducer,
});
